// removed by extract-text-webpack-plugin
module.exports = {"box":"_14RkMCTQW-P5NDNKa0H2sP","boxTitle":"oaMP5OvFAQNvhw9qmjxF","boxSubtitle":"_2hq4gcM6QRbU8cbD3ogVWV","boxBar":"_2YySTWfqSuFqwJRno4ihxn","content":"_3PKiQZtPdCCVYrKm-ONzhx","listing":"z91OkjrLCsMDSJN5z3iMU","listingHeader":"_2LzXkaRv1fi0LX9wTZNYZE","listingContent":"EyMgtpaFfMvRNyD_P1TU6","boxInfo":"cpVK9ggZJvBqzOITm8rmY"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Documents/Documents.scss
// module id = 924
// module chunks = 0